import { render, staticRenderFns } from "./RetailDetail.vue?vue&type=template&id=2d7ab3d8&scoped=true&"
import script from "./RetailDetail.vue?vue&type=script&lang=js&"
export * from "./RetailDetail.vue?vue&type=script&lang=js&"
import style0 from "./RetailDetail.vue?vue&type=style&index=0&id=2d7ab3d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7ab3d8",
  null
  
)

export default component.exports